// Libs
import { useDispatch } from 'react-redux';

// Actions
import { EditKitName, CleanKitActionErrorMessage } from '../../../actions/kits';
import { OpenModal, CloseModal } from '../../../actions/modal';

// Components
import KitNameModal from '../../../components/Kits/Modal/KitNameModal/KitNameModal';

// Hooks
import useUI from '../../../hooks/useUI';

// Constants
import {
  FORM_MODAL_HEIGHT_DESKTOP,
  FORM_MODAL_HEIGHT_MOBILE,
  FORM_MODAL_WIDTH_DESKTOP,
  FORM_MODAL_WIDTH_MOBILE,
  FORM_MODAL_WIDTH_TABLET,
} from '../../../constants/modals';

const useEditKit = () => {
  const dispatch = useDispatch();
  const { isTabletMode, isMobileMode } = useUI();

  const onClickSave = (kitId, name) => {
    dispatch(EditKitName({ kitId, name }));
  };

  const onClickCancel = () => {
    dispatch(CloseModal());
  };

  const cleanUp = () => {
    dispatch(CleanKitActionErrorMessage());
  };

  const onEditKitName = (kitId, oldName) => {
    let width;
    if (isMobileMode) {
      width = FORM_MODAL_WIDTH_MOBILE;
    } else if (isTabletMode) {
      width = FORM_MODAL_WIDTH_TABLET;
    } else {
      width = FORM_MODAL_WIDTH_DESKTOP;
    }

    dispatch(
      OpenModal({
        Component: KitNameModal,
        props: {
          entityId: kitId,
          header: 'Edit kit nickname',
          oldName,
          onClickSave,
          onClickCancel,
          cleanUp,
          paddingContent: {
            xl: '40px 40px 30px',
            lg: '40px 40px 30px',
            md: '24px 16px 24px',
          },
        },
        styles: {
          width,
          height: isMobileMode
            ? FORM_MODAL_HEIGHT_MOBILE
            : FORM_MODAL_HEIGHT_DESKTOP,
        },
      }),
    );
  };

  return { onEditKitName };
};

export default useEditKit;
